import { TextField } from '@mui/material';

interface LlmEndpointFieldProps {
  value: string;
  error?: string;
  setValue: (value: string) => void;
}

function LlmEndpointField({
  value,
  error,
  setValue,
}: LlmEndpointFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      label='LLM Endpoint'
      value={value}
      error={Boolean(error)}
      helperText={error}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default LlmEndpointField;

